import styled from "styled-components";

export default c => styled(c)`
  .history-indicators {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    margin-bottom: 16px;
  }

  .history-indicator {
    border-right: 1px solid #ccc;
  }

  .history-indicator:last-child {
    border-right: none;
  }

  .history-indicator-inner {
    padding: 8px;

    strong {
      display: block;
    }

    .value {
      font-size: 1.3em;
    }

    .warning-icon {
      color: #d00;
      vertical-align: middle;
    }
  }

  .graph-options {
    padding: 8px;
  }

  .graph-container {
    padding: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/history-graph/style.js